export const FORMS_ONBOARDING_USER_ATTRIBUTE = 'FormsUI:OnboardingTour';
export const FORMS_ABM_ONBOARDING_USER_ATTRIBUTE = 'FormsUI:ABMOnboardingTour';
export const FORMS_COMMENTING_USER_ATTRIBUTE = 'FormsUI:CommentingUserAttribute';
export const FORMS_PAYMENT_BOOTSTRAPPER_USER_ATTRIBUTE = 'FormsUI:PaymentsBootstrapperUserAttribute';